// React
import React from 'react';
import {useState} from 'react';

// MUI
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';

// others
import { DndProvider } from 'react-dnd';
import { ReactFlowProvider } from '@xyflow/react';
import { HTML5Backend } from 'react-dnd-html5-backend';

import './App.css';
import Dashboard from './Dashboard.jsx';
import Devices from './Devices.jsx';
import Flow from './Flow.jsx';
import Controllers from './Controllers.jsx';
import Settings from './Settings.jsx';

const TabsV = Object.freeze({
    TABS_DASHBOARD: ("dashboard"),
    TABS_DEVICES: ("devices"),
    TABS_FLOW: ("flow"),
    TABS_CONTROLLERS: ("controllers"),
    TABS_SETTINGS: ("settings"),
});

export default function App(props) {
    const [selectedTab, setSelectedTab] = useState(TabsV.TABS_DASHBOARD);

    function handleTabChanged(event, newValue) {
        setSelectedTab(newValue);
    };
    
    return (

            <Box className="App" sx={{overflow:'hidden', display:'flex', flexDirection:'column', width:'100vw', height:'100vh'}}>
                <TabContext value={selectedTab}>
                    <TabList onChange={handleTabChanged} aria-label="basic tabs">
                        <Tab label="Dashboard" id="tab_dashboard" value={TabsV.TABS_DASHBOARD}/>
                        <Tab label="Devices" id="tab_devices" value={TabsV.TABS_DEVICES}/>
                        <Tab label="Flow" id="tab_flow" value={TabsV.TABS_FLOW}/>
                        <Tab label="Controllers" id="tab_controllers" value={TabsV.TABS_CONTROLLERS}/>
                        <Tab label="Settings" id="tab_settings" value={TabsV.TABS_SETTINGS}/>
                    </TabList>
                    <TabPanel value={TabsV.TABS_DASHBOARD} sx={{overflow:'hidden', padding: '0'}}>
                        <Dashboard/>
                    </TabPanel>
                    <TabPanel value={TabsV.TABS_DEVICES} sx={{overflow:'hidden', padding: '0', width:'100%', height:'100%'}}>
                        <Devices/>
                    </TabPanel>
                    <TabPanel value={TabsV.TABS_FLOW} sx={{overflow:'hidden', padding: '0', width:'100%', height:'100%'}}>
                        <DndProvider backend={HTML5Backend}>
                            <ReactFlowProvider>
                                <Flow/>
                            </ReactFlowProvider>
                        </DndProvider>
                    </TabPanel>
                    <TabPanel value={TabsV.TABS_CONTROLLERS} sx={{overflow:'hidden', padding: '0', width:'100%', height:'100%'}}>
                        <Controllers/>
                    </TabPanel>
                    <TabPanel value={TabsV.TABS_SETTINGS} sx={{overflow:'hidden', padding: '0', width:'100%', height:'100%'}}>
                        <Settings/>
                    </TabPanel>
                </TabContext>
            </Box>

    );
};

